const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

let lastActivityAt = Date.now();

function markActivity() {
  lastActivityAt = Date.now();
}

ACTIVITY_EVENTS.forEach((event) => {
  window.addEventListener(event, markActivity, { passive: true });
});

export function hasRecentActivity(withinMs) {
  return Date.now() - lastActivityAt <= withinMs;
}
